import { COMPONENT_TYPES } from "helpers/utils/constants";
import { getDefaultIconByType, linkByComponent } from "helpers/utils/utilities";
import { Link } from "react-router-dom";

export const getJobNetworkNotificationIcon = (type, data) => {
  switch (type) {
    case "application_received":
    case "application_shortlisted":
    case "interview_request":
    case "position_offered":
    case "hired":
    case "application_rejected":
    case "job_deleted":
      return getDefaultIconByType(COMPONENT_TYPES.ORGANIZATION);
    case "job_applied":
    case "offer_accepted":
    case "offer_rejected":
      return data?.user?.profile_image;
  }
};


export const getJobNetworkNotificationContentByType = (type, data) => {
  switch (type) {
    case "application_received":
      return (
        <Text>
          <NLink
            component={COMPONENT_TYPES.ORGANIZATION}
            slug={data?.organization?.slug}
          >
            {data?.organization?.title}
          </NLink>{" "}
          has received your application for the{" "}
          <NLink component={COMPONENT_TYPES.JOB_NETWORK} slug={data?.job?.id}>
            {data?.job?.title || "N/A"}
          </NLink>{" "}
          position.
        </Text>
      );
    case "application_shortlisted":
      return (
        <Text>
          <NLink
            component={COMPONENT_TYPES.ORGANIZATION}
            slug={data?.organization?.slug}
          >
            {data?.organization?.title}
          </NLink>{" "}
          has shortlisted your application for the
          <NLink component={COMPONENT_TYPES.JOB_NETWORK} slug={data?.job?.id}>
            {data?.job?.title || "N/A"}
          </NLink>{" "}
          position.
        </Text>
      );
    case "interview_request":
      return (
        <Text>
          <NLink
            component={COMPONENT_TYPES.ORGANIZATION}
            slug={data?.organization?.slug}
          >
            {data?.organization?.title}
          </NLink>{" "}
          wants to interview you for the
          <NLink component={COMPONENT_TYPES.JOB_NETWORK} slug={data?.job?.id}>
            {data?.job?.title || "N/A"}
          </NLink>{" "}
          position.
        </Text>
      );

    case "position_offered":
      return (
        <Text>
          <NLink
            component={COMPONENT_TYPES.ORGANIZATION}
            slug={data?.organization?.slug}
          >
            {data?.organization?.title}
          </NLink>{" "}
          has offered you the
          <NLink component={COMPONENT_TYPES.JOB_NETWORK} slug={data?.job?.id}>
            {data?.job?.title || "N/A"}
          </NLink>{" "}
          position.
        </Text>
      );

    case "hired":
      return (
        <Text>
          Congratulations!
          <NLink
            component={COMPONENT_TYPES.ORGANIZATION}
            slug={data?.organization?.slug}
          >
            {data?.organization?.title}
          </NLink>{" "}
          has hired you for the
          <NLink component={COMPONENT_TYPES.JOB_NETWORK} slug={data?.job?.id}>
            {data?.job?.title || "N/A"}
          </NLink>{" "}
          position.
        </Text>
      );
    case "application_rejected":
      return (
        <Text>
          <NLink
            component={COMPONENT_TYPES.ORGANIZATION}
            slug={data?.organization?.slug}
          >
            {data?.organization?.title}
          </NLink>{" "}
          has rejected you for the
          <NLink component={COMPONENT_TYPES.JOB_NETWORK} slug={data?.job?.id}>
            {data?.job?.title || "N/A"}
          </NLink>{" "}
          position.
        </Text>
      );
    case "job_deleted":
      return (
        <Text>
          <NLink
            component={COMPONENT_TYPES.ORGANIZATION}
            slug={data?.organization?.slug}
          >
            {data?.organization?.title}
          </NLink>{" "}
          has deleted the posting for the
          <NLink component={COMPONENT_TYPES.JOB_NETWORK} slug={data?.job?.id}>
            {data?.job?.title || "N/A"}
          </NLink>{" "}
          position.
        </Text>
      );
    case "job_applied":
      return (
        <Text>
          <NLink component={COMPONENT_TYPES.USER} slug={data?.user?.username}>
            {data?.user?.full_name}
          </NLink>{" "}
          applied for the
          <NLink component={COMPONENT_TYPES.JOB_NETWORK} slug={data?.job?.id}>
            {data?.job?.title || "N/A"}
          </NLink>{" "}
          position.
        </Text>
      );
    case "offer_rejected":
      return (
        <Text>
          <NLink component={COMPONENT_TYPES.USER} slug={data?.user?.username}>
            {data?.user?.full_name}
          </NLink>{" "}
          has rejected the offer for the
          <NLink component={COMPONENT_TYPES.JOB_NETWORK} slug={data?.job?.id}>
            {data?.job?.title || "N/A"}
          </NLink>{" "}
          position.
        </Text>
      );
    case "offer_accepted":
      return (
        <Text>
          <NLink component={COMPONENT_TYPES.USER} slug={data?.user?.username}>
            {data?.user?.full_name}
          </NLink>{" "}
          has accepted the offer for the
          <NLink component={COMPONENT_TYPES.JOB_NETWORK} slug={data?.job?.id}>
            {data?.job?.title || "N/A"}
          </NLink>{" "}
          position.
        </Text>
      );
  }
};

const Text = ({ children }) => {
  return <p className="c-title fs-14">{children}</p>;
};

const NLink = ({ children, component, slug }) => {
  return (
    <Link
      className="link mx-1 uppercase tracking-tight"
      to={linkByComponent(component, slug)}
      target="_blank"
    >
      {children}
    </Link>
  );
};
